import { escapeRegExp, get, isUndefined } from 'lodash';
import { CONTAINS, EQUALS, HAS_KEY, IS_FALSY, IS_NONE, IS_TRUTHY, ONE_OF, STRICT_EQUAL } from '../operators';

/**
 * Returns true if the object matches the query
 *
 * The category field is ignored;
 * The field id will be used in lodash.get to assess the field value;
 * Assumes true when no condition is given;
 *
 * @param {object} query Query to check
 * @param {object} object Object to match against the query
 */
export function matchObject(query, object) {
    return !query?.AND?.find(
        (group) =>
            !group.OR.find(({ field, operator, values: possibleValues }) => {
                let fieldValue = get(object, field);

                switch (operator) {
                    case IS_NONE:
                        return isUndefined(fieldValue);
                    case ONE_OF:
                    case EQUALS:
                        return possibleValues.findIndex((v) => fieldValue?.toString().match(createEqualsExpr(v))) !== -1;
                    case CONTAINS:
                        return possibleValues.findIndex((v) => fieldValue?.toString().match(createContainExpr(v))) !== -1;
                    case IS_TRUTHY:
                        return !!fieldValue;
                    case IS_FALSY:
                        return !fieldValue;
                    case STRICT_EQUAL:
                        return possibleValues.findIndex((v) => fieldValue === v) !== -1;
                    case HAS_KEY:
                        return possibleValues.findIndex((v) => fieldValue?.hasOwnProperty(v)) !== -1;
                    default:
                        console.warn(`Unsupported operator type: ${operator}`);
                        return true;
                }
            })
    );
}

function createContainExpr(string) {
    return new RegExp(escapeRegExp(string), 'ig');
}

function createEqualsExpr(string) {
    return new RegExp(`^${escapeRegExp(string)}$`, 'ig');
}
